import React, { useEffect, useState } from 'react';
import { PillButton } from './PillButton';
import { PeerBenchmark } from './PeerBenchmark';
import { useSnakSession } from '../contexts/SnakSession';
import { trackingPriorOptions } from '../data/teaser';
interface PollOverlayProps {
  open: boolean;
  onClose: () => void;
}

/**
 * Optional aside. Captures TRACKING_PRIOR, pays it back with the peer split,
 * then returns the reader to the story.
 */
export function PollOverlay({
  open,
  onClose
}: PollOverlayProps) {
  const {
    answers,
    submit,
    benchmark
  } = useSnakSession();
  const chosen = answers.TRACKING_PRIOR;
  const [revealed, setRevealed] = useState(false);
  const peers = benchmark('TRACKING_PRIOR', trackingPriorOptions);
  useEffect(() => {
    if (!open) return;
    const onKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);
  useEffect(() => {
    if (open && chosen) setRevealed(true);
  }, [open, chosen]);
  if (!open) return null;
  return <div className="absolute inset-0 z-20 flex items-end bg-solventum-bg/85 px-1 pb-1 backdrop-blur-md animate-fade-in" role="dialog" aria-modal="true" aria-label="Your view" data-id="element-94" data-mp="3j4uq4cem12uc">
      <div className="w-full rounded-3xl border border-white/12 bg-white/[0.06] p-5 opacity-0-init animate-fade-in-up" style={{
      animationDelay: '60ms'
    }} data-id="element-95" data-mp="3stw2lsly523k">
        <p className="font-body text-[10px] font-semibold uppercase tracking-[0.26em] text-solventum-primary" data-id="element-96" data-mp="305qh33n2j92o">
          Your view
        </p>

        {!revealed ? <>
            <p className="mt-3 font-headline text-[19px] font-extrabold leading-snug text-white" data-id="element-97" data-mp="3e2x1f2nfxfu0">
              When tracking is off, what do you check first?
            </p>

            <div className="mt-5 flex flex-col gap-2" data-id="element-98" data-mp="td7mkpmqlu1b">
              {trackingPriorOptions.map(option => <PillButton key={option} size="md" variant="outline" className="w-full justify-start" onClick={() => {
            submit('TRACKING_PRIOR', option);
            setRevealed(true);
          }} data-id="element-99" data-mp="pfibtj4qmlb8">
                  {option}
                </PillButton>)}
            </div>

            <div className="mt-4 flex justify-end" data-id="element-100" data-mp="2zho81iwamemh">
              <PillButton variant="ghost" onClick={onClose} data-id="element-101" data-mp="2zj96vkpn4jq5">
                Skip
              </PillButton>
            </div>
          </> : <>
            <p className="mt-3 font-body text-xs text-white/50" data-id="element-102" data-mp="38h1mkpz9xte2">
              You chose{' '}
              <span className="font-headline font-extrabold text-solventum-primary" data-id="element-103" data-mp="3d92s7t1xslv4">
                {chosen}
              </span>
            </p>

            <p className="mt-4 font-body text-[10px] font-semibold uppercase tracking-[0.22em] text-white/35" data-id="element-104" data-mp="2gou4dl44e8xk">
              Peer responses
            </p>

            <div className="mt-3" data-id="element-105" data-mp="2d7y0cf6g864r">
              <PeerBenchmark benchmark={peers} chosen={chosen} revealed data-id="element-106" data-mp="2d87py1nl0b9x" />
            </div>

            <div className="mt-5 flex justify-end" data-id="element-107" data-mp="28apg891qps0v">
              <PillButton variant="solid" onClick={onClose} data-id="element-108" data-mp="247t32xuyyo4b">
                Back to the story
              </PillButton>
            </div>
          </>}
      </div>
    </div>;
}